import { defaultPeriscopeState } from '../read/state';
export function removePeriscope(removePeriscopeSync, state) {
    const { periscopeIndex } = removePeriscopeSync;
    return Object.assign(Object.assign({}, defaultPeriscopeState), { cards: [...state.cards.slice(0, periscopeIndex)] });
}
